var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-widget-container" },
    [
      _c(
        "el-form",
        {
          staticClass:
            "full-height-width widget-form custom-class layoutType-layout",
          attrs: {
            "label-position": "top",
            size: "medium",
            "validate-on-rule-change": false,
          },
        },
        [
          _vm.designer.widgetList.length &&
          _vm.designer.widgetList[0].widgetList.length === 0
            ? _c("div", { staticClass: "no-widget-hint" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/no-widget-hint.png"),
                    alt: "",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "trip" }, [
                  _vm._v("暂无图表,请从右侧点击添加"),
                ]),
              ])
            : _c(
                "div",
                { staticClass: "form-widget-canvas" },
                [
                  _c(
                    "draggable",
                    {
                      attrs: {
                        list: _vm.designer.widgetList,
                        "item-key": "id",
                        group: "dragGroup",
                        "ghost-class": "ghost",
                        animation: "400",
                        tag: "div",
                        "component-data": {
                          name: "fade",
                          class: "canvas-drag-drop-zone",
                        },
                        handle: ".drag-handler",
                        move: _vm.checkMove,
                      },
                      on: {
                        end: _vm.onDragEnd,
                        add: _vm.onDragAdd,
                        update: _vm.onDragUpdate,
                      },
                    },
                    [
                      _vm._l(_vm.designer.widgetList, function (g, y) {
                        return [
                          g.category === "container"
                            ? _c(_vm.getWidgetName(g), {
                                tag: "component",
                                attrs: {
                                  widget: g,
                                  designer: _vm.designer,
                                  "parent-list": _vm.designer.widgetList,
                                  "index-of-parent-list": y,
                                  "parent-widget": null,
                                },
                              })
                            : _c(_vm.getWidgetName(g), {
                                tag: "component",
                                attrs: {
                                  field: g,
                                  designer: _vm.designer,
                                  "parent-list": _vm.designer.widgetList,
                                  "index-of-parent-list": y,
                                  "parent-widget": null,
                                  "design-state": "true",
                                },
                              }),
                        ]
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }